import {
  Button,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Dialog,
  DialogContent,
  DialogActions,
  Divider,
} from '@mui/material';
import cloneDeep from 'lodash/cloneDeep';
import React, { useEffect } from 'react';

interface IProps {
  totalDate: number;
  isOpen: boolean;
  toggleDuplicateModal: () => void;
  selectedDay: number;
  saveDuplicateModal: (
    duplicate: { day: number; checked: boolean; selectedDay: boolean }[],
    selectedDay: number,
  ) => void;
}

const defaultAllDayCheckbox = [
  { value: 1, day: 'all-1', checked: false },
  { value: 2, day: 'all-2', checked: false },
  { value: 3, day: 'all-3', checked: false },
  { value: 4, day: 'all-4', checked: false },
  { value: 5, day: 'all-5', checked: false },
  { value: 6, day: 'all-6', checked: false },
  { value: 7, day: 'all-7', checked: false },
];

export function ChallengeDuplicateModal({
  totalDate,
  selectedDay,
  isOpen,
  toggleDuplicateModal,
  saveDuplicateModal,
}: IProps) {
  const [duplicateList, setDuplicateList] = React.useState<
    { day: number; checked: boolean; selectedDay: boolean }[]
  >(() => []);
  const initCheckbox = (totalDate: number, selectedDay: number) => {
    const result = [];

    for (let i = 1; i < totalDate + 1; i += 1) {
      result.push({
        day: i,
        selectedDay: selectedDay === i,
        checked: selectedDay === i,
      });
    }

    return result;
  };
  const [allDayCheckbox, setAllDayCheckbox] = React.useState<
    typeof defaultAllDayCheckbox
  >(defaultAllDayCheckbox);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const copyList = cloneDeep(duplicateList);

    copyList[Number(event.target.name)].checked = !copyList[
      Number(event.target.name)
    ].checked;

    setDuplicateList(copyList);
  };

  const handleAllChecked = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const parseValue = +value;

    const copyList = cloneDeep(allDayCheckbox);

    copyList[parseValue - 1].checked = !copyList[parseValue - 1].checked;
    setAllDayCheckbox(copyList);

    let duplicateCount = 0;

    setDuplicateList(
      duplicateList.map((duplicate) => {
        const mathLineDay = 7 * duplicateCount;
        const lineDay: number =
          duplicate.day <= 7 ? parseValue : parseValue + mathLineDay;

        if (lineDay <= totalDate && duplicate.day === lineDay) {
          duplicateCount += 1;
          return {
            ...duplicate,
            checked: !duplicate.checked,
          };
        }

        return duplicate;
      }),
    );
  };

  const handleCloseModal = () => {
    setDuplicateList([]);
    toggleDuplicateModal();
  };

  const onClickSave = () => {
    saveDuplicateModal(duplicateList, selectedDay);
    setDuplicateList(initCheckbox(totalDate, selectedDay));
    handleCloseModal();
  };

  useEffect(() => {
    if (totalDate > 0 && duplicateList.length === 0 && isOpen) {
      setDuplicateList(initCheckbox(totalDate, selectedDay));
    }
  }, [totalDate, selectedDay, duplicateList, setDuplicateList, isOpen]);

  return (
    <Dialog
      keepMounted
      open={isOpen}
      onClose={handleCloseModal}
      aria-labelledby='keep-mounted-modal-title'
      aria-describedby='keep-mounted-modal-description'
    >
      <DialogContent>
        <FormGroup row>
          {allDayCheckbox.map((all) => {
            return (
              <FormControlLabel
                sx={{
                  width: '13%',
                  '& .MuiFormControlLabel-label': { fontSize: 10 },
                }}
                key={all.day}
                control={
                  <Checkbox
                    value={all.value}
                    color='error'
                    size='small'
                    checked={all.checked}
                    onChange={handleAllChecked}
                    name={all.day}
                  />
                }
                label='라인'
              />
            );
          })}
          <Divider
            sx={{ width: '100%', borderWidth: 2, borderColor: '#dedede' }}
          />
          {duplicateList.length > 0 &&
            duplicateList.map((item) => {
              return (
                <FormControlLabel
                  sx={{
                    width: '13%',
                    '& .MuiFormControlLabel-label': { fontSize: 10 },
                  }}
                  key={item.day}
                  disabled={item.selectedDay}
                  control={
                    <Checkbox
                      size='small'
                      checked={item.checked}
                      onChange={handleChange}
                      name={String(item.day - 1)}
                    />
                  }
                  label={`${item.day}일차`}
                />
              );
            })}
        </FormGroup>
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={handleCloseModal}>
          취소
        </Button>
        <Button variant='contained' onClick={onClickSave}>
          적용
        </Button>
      </DialogActions>
    </Dialog>
  );
}
